import recommendationsModule from "../recommendationsModule.js";

const recommendationsConstants = {
    recommendationTypes: {
        assets: 0,
        bundles: 1
    },
    recommendationSubtypes: {
        gamePasses: 21,
        badges: 34
    },
    urls: {
        catalog: "/catalog"
    }
};

recommendationsModule.constant("recommendationsConstants", recommendationsConstants);
export default recommendationsConstants;